import { isPublicReviewPath } from "./publicReviewPath";

export type AppProviderMode = "public" | "internal";

export function getAppProviderMode(pathname: string): AppProviderMode {
  return isPublicReviewPath(pathname) ? "public" : "internal";
}

export function resolveProviderPathname(
  renderedRoutePathname: string | undefined,
  historyPathname: string,
): string {
  return renderedRoutePathname ?? historyPathname;
}

export function isAppProviderModeAligned(
  providerMode: AppProviderMode,
  routerPathname: string,
  historyPathname: string,
): boolean {
  return providerMode === getAppProviderMode(routerPathname)
    && providerMode === getAppProviderMode(historyPathname);
}
